import React from 'react'
import Main from '../Product/Main'
import MainSec2 from '../Product/MainSec2'

export const Product = () => {
  return (
    <>
    <Main />
    <MainSec2 />
    </>
  )
}
